module.exports = __webpack_public_path__ + "static/media/miniinfinity.5aefdbfa.jpg";